import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { SIMPLE_ALLERGEN_FRAGMENT } from '../fragments'

const DELETE_ALLERGEN_MUTATION = gql`
  mutation deleteAllergen($id: ID!) {
    deleteAllergen(id: $id) {
      results {
        ...SimpleAllergenFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${SIMPLE_ALLERGEN_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default DELETE_ALLERGEN_MUTATION
